import request from '@/config';

enum Apis {
	StampUseReportList = `/api/stampusereport/getstampuselist`,
	StampUseExport = `/api/stampusereport/exportstampuse`,
	PerformReportList = `/api/contractperforms/getcontractperformlist`,
	ContractPerformExport = `/api/contractperforms/exportcontractperform`,
}

export const GetPerformReportApi = (search: any): Promise<IResponse> =>
	request.post({
		url: Apis.PerformReportList,
		data: search,
	});

export const StampUseExportApi = (search: any): Promise<IResponse> =>
	request.post({
		url: Apis.StampUseExport,
		data: search,
		responseType: 'blob',
	});

export const GetStampUseReportApi = (search: any): Promise<IResponse> =>
	request.post({
		url: Apis.StampUseReportList,
		data: search,
	});

export const ContractPerformExportApi = (search: any): Promise<IResponse> =>
	request.post({
		url: Apis.ContractPerformExport,
		data: search,
		responseType: 'blob',
	});